// Рантайм-признак «мы внутри нативной Capacitor-оболочки».
//
// Внутри packages/platform недоступен `IS_CAPACITOR` из apps/web (Vite define
// `__IS_CAPACITOR__` — build-time флаг конкретного приложения, и пакет не должен
// на него завязываться, иначе он не переиспользуем и ломает typecheck пакета).
// Нативный мост кладёт `window.Capacitor` до загрузки бандла, поэтому проверка
// платформы честнее флага сборки: mobile-dev бандл, открытый в десктопном
// браузере для отладки LAN-стенда, корректно считается НЕ нативным.
export function isCapacitorRuntime(): boolean {
	if (typeof window === "undefined") return false;
	const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
	return typeof cap?.isNativePlatform === "function" ? cap.isNativePlatform() : false;
}
